module.exports = __webpack_public_path__ + "img/task-active.36c3005c.svg";